import { useState, useEffect } from 'react';
import { useLanguage } from '../../providers/preferenceProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faObjectUngroup, faBuilding, faCrown } from '@fortawesome/free-solid-svg-icons';


const SearchableSelect = ({ label, icon, options, value, onChange, placeholder, name, required = false, error = false, onSearch, clear }) => {
  const [search, setSearch] = useState('');
  const { t } = useLanguage();
  const [filteredOptions, setFilteredOptions] = useState([]);
  const placeholderText = placeholder || t.select + "...";

  var iconRef = faObjectUngroup;
  if (icon === "type") iconRef = faObjectUngroup;
  else if (icon === "company") iconRef = faBuilding;
  else if (icon === "role") iconRef = faCrown;

  useEffect(() => {
    // Find the option that matches the value and set its label
    const selected = options.find(option => {
      if (typeof option === 'object') return option.id === value;
      return option === value;
    });
    onSearch ?? setSearch(selected ? (typeof selected === 'object' ? selected.name : selected) : '');
  }, [value, options]);

  useEffect(() => {
    setSearch('');
  }, [clear]);

  const [isOpen, setIsOpen] = useState(false);
  const getDisplayLabel = (option) => typeof option === 'object' ? option.name : option;
  const getValue = (option) => typeof option === 'object' ? option.id : option;

  useEffect(() => {
    setFilteredOptions(onSearch ? onSearch(search) : options.filter(option => {
      const label = getDisplayLabel(option);
      return label && label.toLowerCase().includes((search || '').toString().toLowerCase());
    }))
  }, [search]);

  useEffect(() => {
    setFilteredOptions(onSearch ? options : options.filter(option => {
      const label = getDisplayLabel(option);
      return label && label.toLowerCase().includes((search || '').toString().toLowerCase());
    }))
  }, [options]);

  const handleSelect = (option) => {
    setSearch(getDisplayLabel(option));
    onChange(getValue(option));
    setIsOpen(false);
  };

  return (
    <div className="flex flex-row items-center gap-4 w-full">
      {label && (
        <label htmlFor={name} className="w-32">
          <FontAwesomeIcon icon={iconRef} /> {label}
        </label>
      )}
      <div className="relative w-full">
        <input
          type="text"
          name={name}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setTimeout(() => setIsOpen(false), 150)}
          placeholder={placeholderText}
          className={"overlay-admin-input w-full" + (error ? " input-error" : "")}
          required={required}
        />
        {isOpen && (
          <ul className="overlay-search-dropdown">
            {filteredOptions && filteredOptions.map((option, index) => (
              <li
                key={index}
                onClick={() => handleSelect(option)}
              >
                {getDisplayLabel(option)}
              </li>
            ))}
            {filteredOptions?.length === 0 && (
              <li>{t.no_results}</li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SearchableSelect;